// extracted by mini-css-extract-plugin
export default {"container":"PointsInfo_container__q-bGX","wrapper":"PointsInfo_wrapper__Y784j"};